import { omit } from 'lodash';
import { JobApplicationType } from '../../domain/types';
import {
  JobApplicationGeneric, JobApplicationSales, JobApplication, JobPosition,
} from '../../providers/api/dtos';
import { booleanStringToBool, boolToBooleanString } from '../../utils/boolean-string/booleanString';
import { JobApplicationGenericFormModel, JobApplicationSalesFormModel } from '../types';

export const jobApplicationToJobApplicationFormModel = (jobApplication: JobApplication, jobPosition: JobPosition): JobApplicationGenericFormModel | JobApplicationSalesFormModel => {
  let mapping = {
    applicationType: jobApplication.applicationType,
    jobPosition,
    source: jobApplication.source,
    experience: jobApplication.experience,
    isEmployed: boolToBooleanString(jobApplication.isEmployed),
  } as JobApplicationGenericFormModel;

  if (jobApplication.applicationType === JobApplicationType.SALES) {
    mapping = {
      ...mapping,
      provinces: jobApplication.provinces,
      hasLicense: boolToBooleanString(jobApplication.hasLicense),
      licenseId: jobApplication.licenseId,
    } as JobApplicationSalesFormModel;
  }

  return mapping;
};

export const jobApplicationFormModelToJobApplication = (existingJobApplication: JobApplication, jobApplicationFormModel: JobApplicationGenericFormModel | JobApplicationSalesFormModel): JobApplication => {
  let mapping: JobApplicationSales | JobApplicationGeneric = {
    ...existingJobApplication,
    jobPositionId: jobApplicationFormModel.jobPosition?.id!,
    experience: jobApplicationFormModel.experience,
    isEmployed: booleanStringToBool(jobApplicationFormModel.isEmployed),
  };

  if (jobApplicationFormModel.applicationType === JobApplicationType.SALES) {
    const model = jobApplicationFormModel as JobApplicationSalesFormModel;
    mapping = {
      ...mapping,
      applicationType: JobApplicationType.SALES,
      provinces: model.provinces,
      hasLicense: booleanStringToBool(model.hasLicense),
      licenseId: model.licenseId,
    } as JobApplicationSales;
  } else {
    mapping = {
      // Nota: ripulire tutti i campi che sono relativi ad altri, più specifici, application type
      ...omit(mapping, ['provinces', 'hasLicense', 'licenseId']),
      applicationType: JobApplicationType.GENERIC,
    } as JobApplicationGeneric;
  }

  return mapping;
};
